import type { SVGProps } from 'react';

type CheckInIconProps = SVGProps<SVGSVGElement> & { size?: number };

export function CheckInIcon({
  size = 24,
  color = 'currentColor',
  ...props
}: CheckInIconProps) {
  return (
    <svg
      viewBox="0 0 19 19"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12.5016 3.33496L14.1683 5.00163L17.5016 1.66829M17.5016 9.16829V13.5016C17.5016 14.9018 17.5016 15.6018 17.2291 16.1366C16.9895 16.607 16.607 16.9895 16.1366 17.2291C15.6018 17.5016 14.9018 17.5016 13.5016 17.5016H4.83496C3.43483 17.5016 2.73476 17.5016 2.19998 17.2291C1.72958 16.9895 1.34713 16.607 1.10744 16.1366C0.834961 15.6018 0.834961 14.9018 0.834961 13.5016V4.83496C0.834961 3.43483 0.834961 2.73476 1.10744 2.19998C1.34713 1.72958 1.72958 1.34713 2.19998 1.10744C2.73476 0.834961 3.43483 0.834961 4.83496 0.834961H9.16829M0.956217 15.7736C1.34717 14.3671 2.6371 13.335 4.1681 13.335H10.0014C10.7759 13.335 11.1631 13.335 11.4851 13.399C12.8074 13.662 13.841 14.6957 14.1041 16.018C14.1681 16.34 14.1681 16.7272 14.1681 17.5016M10.835 7.08496C10.835 8.92591 9.34258 10.4183 7.50163 10.4183C5.66068 10.4183 4.16829 8.92591 4.16829 7.08496C4.16829 5.24401 5.66068 3.75163 7.50163 3.75163C9.34258 3.75163 10.835 5.24401 10.835 7.08496Z" />
    </svg>
  );
}
